import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { formConsumer } from 'core/form';
import { Flex } from 'core/components';
import {
  KENTIK_TENANCY_ID,
  KENTIK_USER_GROUP_ID,
  KENTIK_USER_GROUP_ID_OUR1
} from '@kentik/ui-shared/util/oci/constants';

import ScriptDisplay from './utils/ScriptDisplay';
import { TAB_ID_CROSS_TENENCY_POLICY, generatePolicy } from './utils/constants';

@inject('$cloudExportWizard', '$dictionary')
@formConsumer
@observer
class OciPolicyPreview extends Component {
  get completePolicyDefinitions() {
    const { $cloudExportWizard } = this.props;

    return generatePolicy({
      crossTenancy:
        $cloudExportWizard.getFieldValue('properties.oci_api_access_method') === TAB_ID_CROSS_TENENCY_POLICY,
      includeFlowLogs: $cloudExportWizard.isFlowLogCollectionEnabled
    });
  }

  render() {
    const { $dictionary } = this.props;
    const kentikUserGroup =
      $dictionary.get('envName') === 'OurPrem1' ? KENTIK_USER_GROUP_ID_OUR1 : KENTIK_USER_GROUP_ID;
    return (
      <Flex data-testid="OciPolicyPreviewStep" flexDirection="column">
        <ScriptDisplay
          source={this.completePolicyDefinitions.join('\r')}
          data={{
            kentikTenancyId: KENTIK_TENANCY_ID,
            kentikUserGroup
          }}
        />
      </Flex>
    );
  }
}

export default OciPolicyPreview;
